import React from "react";
import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";

import { pageSeo } from "../../seo/pageSeo";

const PageSeo = () => {
  const location = useLocation();

  const seo = pageSeo[location.pathname];

  if (!seo) return null;

  return (
    <Helmet>
      <title>{seo.title}</title>

      <meta
        name="description"
        content={seo.description}
      />

      <link
        rel="canonical"
        href={seo.canonical}
      />

      {/* Open Graph */}
      <meta property="og:type" content="website" />

      <meta
        property="og:title"
        content={seo.title}
      />

      <meta
        property="og:description"
        content={seo.description}
      />

      <meta
        property="og:url"
        content={seo.canonical}
      />

      {/* Twitter */}
      <meta
        name="twitter:card"
        content="summary_large_image"
      />

      <meta
        name="twitter:title"
        content={seo.title}
      />

      <meta
        name="twitter:description"
        content={seo.description}
      />

      {/* FAQ Schema */}
      {seo.faqSchema && (
        <script type="application/ld+json">
          {JSON.stringify(seo.faqSchema)}
        </script>
      )}
    </Helmet>
  );
};

export default PageSeo;